import moment from "moment";
type ActivityType = {
  id: string;
  date: string;
  title: string;
  startTime: string;
  endTime: string;
  left: string;
  top: string;
  related_competency: any;
  height: string;
  width: string;
  event_type_val: number;
};
export const generateDates = (start: any, end: any) => {
  for (
    var arr = [],
      dt = new Date(start),
      de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
    dt <= new Date(end);
    dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
  ) {
    arr.push(moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"));
  }
  return arr;
};
export const generateCalendarDates = (start: any, end: any) => {
  var startDate = new Date(start);
  var endDate = new Date(end);
  for (
    var arr = [], dt = startDate;
    dt <= endDate;
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(moment(dt).format("ddd DD"));
  }
  return arr;
};
export const generateHeaderwidth = (count: any) => {
  return count * 157 + "px";
};
export const generateTime = () => {
  const times: Array<any> = [];
  for (let index = 7; index <= 12; index++) {
    if (index === 12) {
      times.push(index + "  PM");
    } else {
      times.push(index + "  AM");
    }
  }
  for (let index = 1; index <= 12; index++) {
    if (index === 12) {
      times.push(index + "  AM");
    } else {
      times.push(index + "  PM");
    }
  }
  return times;
};
export const generateRoadmapDates = (start: any, end: any) => {
  var dateOffset = 24 * 60 * 60 * 1000 * 5; //5 days
  var startDate = new Date(start);
  startDate.setTime(startDate.getTime() - dateOffset);
  var endDate = new Date(end);
  endDate.setTime(endDate.getTime() + dateOffset);
  for (
    var arr = [], dt = startDate;
    dt <= endDate;
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(moment(dt).format("DD MMM"));
  }
  return arr;
};
export const generateActivityDates = (start: any, end: any) => {
  var startDate = new Date(start);
  var endDate = new Date(end);
  for (
    var arr = [], dt = startDate;
    dt <= endDate;
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(moment(dt).format("DD MMM"));
  }
  return arr;
};
const calculateLeft = (startDate: any, actualDate: any) => {
  const days = dateDiffDays(startDate, actualDate);
  const left = 95 + days * 190;
  return left + "px";
};
const calculateTop = (startTime: any) => {
  const hours = hourDiff(startTime);
  const top = hours * 70;
  return top + "px";
};
export function groupBy(xs: Array<any>, key: string) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

const calculateWidth = (
  activityId: string,
  startTime: string,
  endTime: string,
  actualDate: string,
  activities: Array<any>
) => {
  let counter = 1;
  const sameDayItems = activities.filter(
    (item: any) => item.date === actualDate && item.id !== activityId
  );
  if (sameDayItems.length === 0) {
    return "157px";
  }
  const startAct = moment(startTime, ["h:m a", "H:m"]);
  const endAct = moment(endTime, ["h:m a", "H:m"]);
  sameDayItems.forEach((element: any) => {
    const startTime = moment(element.start_time, ["h:m a", "H:m"]);
    const endTime = moment(element.end_time, ["h:m a", "H:m"]);
    if (
      (endTime.isAfter(startAct) && startTime.isBefore(endAct)) ||
      (endTime.isSame(startAct) && startTime.isSame(endAct))
    ) {
      counter++;
    }
  });
  return counter === 1
    ? "157px"
    : // : counter === 2
      // ? 125 / counter + 'px'
      Number(125 - 18 * 2) / 2 + "px";
};
const calculateHeight = (startTime: any, endTime: any) => {
  const hours = hourDiffBoth(startTime, endTime);
  const height = hours * 70;
  return height + "px";
};
const hourDiff = (actualHour: any) => {
  const startTime = moment("7:00:00 am", "h:mm:ss a");
  const endTime = moment(
    moment(actualHour, "HH:mm").format("h:mm:ss a"),
    "h:mm:ss a"
  );
  const duration = moment.duration(endTime.diff(startTime));
  const hours = Number(duration.asHours());
  return hours;
};
const hourDiffBoth = (start: any, end: any) => {
  const startTime = moment(
    moment(start, "HH:mm").format("h:mm:ss a"),
    "h:mm:ss a"
  );
  const endTime = moment(moment(end, "HH:mm").format("h:mm:ss a"), "h:mm:ss a");
  const duration = moment.duration(endTime.diff(startTime));
  const hours = Number(duration.asHours());
  return hours;
};
const dateDiffDays = (date1S: any, date2S: any) => {
  const date1 = new Date(date1S);
  const date2 = new Date(date2S);

  // To calculate the time difference of two dates
  const Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days;
};
const generateActivity = (activities: Array<any>, firstDate: any) => {
  const calArr: Array<ActivityType> = [];
  const overlaps: Array<ActivityType> = [];
  const notOverlaps: Array<ActivityType> = [];
  activities.forEach((miles, index) => {
    calArr.push({
      title: miles.title,
      startTime: moment(miles.start_time, "HH:mm").format("HH:mm"),
      endTime: moment(miles.end_time, "HH:mm").format("HH:mm"),
      left: calculateLeft(firstDate, miles.date),
      top: calculateTop(miles.start_time),
      height: calculateHeight(miles.start_time, miles.end_time),
      width: calculateWidth(
        miles.id,
        miles.start_time,
        miles.end_time,
        miles.date,
        activities
      ),
      ...miles,
    });
  });
  calArr.forEach((element) => {
    if (Number(element.width.split("px")[0]) < 157) {
      overlaps.push(element);
    } else {
      notOverlaps.push(element);
    }
  });
  let reorderOverlaps = groupBy(overlaps, "date");

  Object.entries(reorderOverlaps).forEach((entry) => {
    const [key, value] = entry;
    if ((value as Array<any>).length > 1) {
      (value as Array<any>).forEach((element, index) => {
        const width =
          index > 0
            ? (value as Array<any>)[index - 1].width
            : (value as Array<any>)[index].width;
        const left =
          index > 0 ? (value as Array<any>)[index - 1].left : element.left;
        element.left =
          index === 0
            ? element.left
            : (value as Array<any>)[index - 1].startTime.split(":")[0] !==
              element.startTime.split(":")[0]
            ? element.left
            : Number(width.split("px")[0]) + Number(left.split("px")[0]) + "px";
        notOverlaps.push(element);
      });
    }
  });
  return notOverlaps;
};

export default generateActivity;
